import { useCallback, useEffect, useState } from 'react';
import { FcDataSheet } from 'react-icons/fc';

import { Box, FormControlLabel, FormGroup, IconButton, Switch, Tooltip } from '@mui/material';
import { CadastroAnimalIndividualIcon /*, CadastroAnimalMultiploIcon*/ } from 'assets/icons/Icons';
import FichaModal from 'components/FichaModal';
import { getAnimalFields } from 'components/GetFields/Animal';
import List from 'components/List';
import { useAuth } from 'contexts/auth';
import { FichaModalStateProps } from 'types/fichaModal';
import { maskDate } from 'utils/MaskDate';

export default function Animais() {
  const { selectedFazenda } = useAuth();
  const [animal, setAnimal] = useState({} as any);
  const [ativo, setAtivo] = useState(true);
  const [daFazenda, setDaFazenda] = useState(true);
  const [fichaModal, setFichaModal] = useState<FichaModalStateProps>({
    open: false,
    codAnimal: '',
  });

  const handleChangeDaFazenda = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDaFazenda(event.target.checked);
  };
  const applyBusinessRules = useCallback(() => {
    if (!ativo) {
      setDaFazenda(true);
    }

    if (!daFazenda) {
      setAtivo(true);
    }
  }, [ativo, daFazenda]);

  useEffect(() => {
    applyBusinessRules();
  }, [ativo, daFazenda, applyBusinessRules]);

  // TODO: Ver como implementar
  // const customSort = (a: any, b: any, orderBy: string) => {
  //   console.log('a', a);
  //   console.log('b', b);
  //   const reA = /[^a-zA-Z]/g;
  //   const reN = /[^0-9]/g;

  //   const aValue = a[orderBy].toLowerCase();
  //   const bValue = b[orderBy].toLowerCase();

  //   const aInt = parseInt(aValue.replace(reN, ''), 10);
  //   const bInt = parseInt(bValue.replace(reN, ''), 10);

  //   const aAlpha = aValue.replace(reA, '');
  //   const bAlpha = bValue.replace(reA, '');

  //   if (isNaN(aInt) && isNaN(bInt)) {
  //     if (aAlpha === bAlpha) {
  //       return 0;
  //     }
  //     return aAlpha > bAlpha ? 1 : -1;
  //   } else if (isNaN(aInt)) {
  //     return 1;
  //   } else if (isNaN(bInt)) {
  //     return -1;
  //   } else {
  //     return aInt > bInt ? 1 : -1;
  //   }
  // };

  return (
    <>
      <Box>
        <FormGroup sx={{ alignItems: 'flex-end', mb: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={daFazenda}
                onChange={handleChangeDaFazenda}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
            label="Animais da fazenda"
          />
        </FormGroup>

        <List
          title="Animal"
          table="animal"
          idColumn="codAnimal"
          selected={animal}
          setSelected={setAnimal}
          registerBtn={{
            icon: <CadastroAnimalIndividualIcon />,
            text: 'Cadastro individual',
          }}
          // secondRegisterBtn={{
          //   icon: <CadastroAnimalMultiploIcon />,
          //   text: 'Cadastro múltiplo',
          // }}
          columns={[
            {
              title: 'Brinco',
              field: 'brinco',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              defaultSort: 'asc',
            },
            { title: 'Nome', field: 'nome', width: 0, cellStyle: { whiteSpace: 'normal' } },
            { title: 'Raça 1', field: 'raca.nome', width: 0, cellStyle: { whiteSpace: 'normal' } },
            {
              title: 'G.S.',
              field: 'grauSangue',
              tooltip: 'Grau de Sangue',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData) => {
                return rowData?.grauSangue ?? '-';
              },
            },
            {
              title: 'Sexo',
              field: 'sexo',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData: any) => {
                if (rowData?.sexo === 1) {
                  return 'Macho';
                } else {
                  return 'Fêmea';
                }
              },
            },
            {
              title: 'Data de Nasc.',
              field: 'dataNasc',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData: any) => {
                const maskedDate = maskDate(rowData?.dataNasc);
                return maskedDate;
              },
            },
            {
              title: 'Pai',
              field: 'genealogia.pai.nome',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData) => {
                return rowData?.genealogia?.pai?.nome ?? '-';
              },
            },
            {
              title: 'Mae',
              field: 'genealogia.mae.nome',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData) => {
                return rowData?.genealogia?.mae?.nome ?? '-';
              },
            },
            {
              title: 'Lote',
              field: 'animalLote.lote.nome',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData) => {
                return rowData?.animalLote?.lote?.nome ?? '-';
              },
            },
            {
              title: 'Ficha',
              field: '',
              width: 0,
              cellStyle: { whiteSpace: 'normal' },
              render: (rowData) => {
                return (
                  <Tooltip title="Mostra ficha">
                    <IconButton
                      onClick={() => setFichaModal({ open: true, codAnimal: rowData?.codAnimal })}
                    >
                      <FcDataSheet />
                    </IconButton>
                  </Tooltip>
                );
              },
            },
          ]}
          data={`animais/getByFazenda/ativo=${ativo}/codFazenda=${selectedFazenda?.codFazenda}/eDaFazenda=${daFazenda}`}
          getFields={getAnimalFields}
        />
      </Box>

      {fichaModal.open && <FichaModal fichaModal={fichaModal} setFichaModal={setFichaModal} />}
    </>
  );
}
